enum QuoteStatusEnum {
    ACTIVE = 1,
    CLOSED = 2,
}

export default QuoteStatusEnum;
